import api from './api';

export const emailService = {
  send: (data) => api.post('/emails/send', data),
  preview: (data) => api.post('/emails/preview', data),
  getAll: (params = {}) => api.get('/emails/', { params }),
  getLogs: (params = {}) => api.get('/emails/logs', { params }),
  getConfigStatus: () => api.get('/emails/config/status'),
};
